import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';

const StyledYouTubePlayer = styled.div`
  position: relative;
  max-width: 100%;
  width: 100%;
  height: 0;
  padding-top: 56.25%;
  background-color: #000;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    border: none;
  }
`;

const YoutubeVideo = ({ youtubeVideoId, ...rest }: YoutubeVideoProps) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <StyledYouTubePlayer {...rest}>
      {isClient && (
        <iframe
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          referrerPolicy="strict-origin-when-cross-origin"
          title="YouTube video"
          width="100%"
          height="100%"
          src={`https://www.youtube-nocookie.com/embed/${youtubeVideoId}?${new URLSearchParams(
            {
              autoplay: '0',
              mute: '0',
              controls: '1',
              playsinline: '1',
              rel: '0',
              iv_load_policy: '3',
              enablejsapi: '1',
              origin: window.location.origin,
            },
          ).toString()}`}
        />
      )}
    </StyledYouTubePlayer>
  );
};

export interface YoutubeVideoProps {
  youtubeVideoId: string;
}

export default YoutubeVideo;
